import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { E as EGDSInput } from '../swapper-input/index-chunk.esm.js';
class EGDSPhoneInput extends React.Component {
  static displayName = 'EGDSPhoneInput';
  render() {
    return jsx(EGDSInput, {
      ...this.props,
      type: "tel"
    });
  }
}
class EGDSEmailInput extends React.Component {
  static displayName = 'EGDSEmailInput';
  render() {
    return jsx(EGDSInput, {
      ...this.props,
      type: "email"
    });
  }
}
const EGDSNumberInput = props => jsx(EGDSInput, {
  ...props,
  type: "number"
});
export { EGDSPhoneInput as E, EGDSEmailInput as a, EGDSNumberInput as b };